import React from "react";
import styles from './DateField.module.scss';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

export interface IDateFieldProps {
  name?: string;
  label?: string;
  value?: any;
  onChange?: any;
  onBlur?: any;
  minDate?: Date;
  maxDate?: Date;
  openTo?: any;
  noBorder?: any;
  valid?: any;
  error?: any;
}

const DateField = (props: IDateFieldProps) => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={"en"}>
      <DateTimePicker
        id={props.name}
        autoOk
        ampm={false}
        fullWidth={true}
        variant="inline"
        inputVariant="outlined"
        label={props.label}
        value={props.value && new Date(props.value)}
        format="MMM D YYYY, HH:mm"
        onChange={props.onChange}
        onBlur={props.onBlur}
        className={`dateTimePicker ${styles.TextField} ${(props.error ? `${styles.error} ` : "")} ${(props.valid ? `${styles.valid}` : "")} ${props.noBorder ? styles.noBorder : ''}`.trim()}
        minDate={props.minDate}
        maxDate={props.maxDate}
        openTo={props.openTo as any}
        invalidLabel={' '}
        invalidDateMessage={' '}
        minDateMessage=' '
        maxDateMessage={' '}
      />
    </MuiPickersUtilsProvider>
  );
};

DateField.defaultProps = {
  name: '',
  label: '',
  value: '',
  onChange: () => {
  },
  onBlur: () => {
  },
  minDate: undefined,
  maxDate: undefined,
  openTo: undefined,
  noBorder: undefined,
  valid: undefined,
  error: undefined,
};

export default DateField;
